import Resource from '@/api/resources/Resource'

class LaboratoryWeekendDaysConfigurationServices extends Resource {
    async updateAllLaboratoryWeekendDays(request, laboratoryId) {
        const response = await this.axios.put(`/configuration/laboratories/${laboratoryId}/weekendDays`, request)
        return response.data
    }
}

export default new LaboratoryWeekendDaysConfigurationServices()
